<template>
  <Contribute></Contribute>
</template>

<script>
import Contribute from "@/components/pinksale/Contribute.vue";

export default {
  name: "PinkSaleContributeView",
  components: {
    Contribute,
  },
};
</script>
